import type { GridColDef } from "@mui/x-data-grid-premium";
import { isUndefined } from "lodash-es";
import type { Visibility } from "../../../../clients/graphqlTypes.js";
import { VisibilityButton } from "../../../commons/VisibilityButton.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { ModifyItemProductFn } from "../quote/useModifyItemProduct.js";
import type { DocDataGridRow } from "../types.js";
import type { ProductColumns__ItemFragment } from "./productColumns.generated.js";

interface Options {
  headerName: string;
  canEdit: boolean;
  viewerIsContractor: boolean;
  modifyItemProduct: ModifyItemProductFn;
}

export function createProductDescriptionVisibilityColumn<
  T extends DocDataGrid_ItemFragment & ProductColumns__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "productDescriptionVisibility",
    headerName: options.headerName,
    width: 40,
    editable: false,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (item.type !== "paid" || item.isItemEliminated) return null;
      if (!item.product) return null;
      if (!options.viewerIsContractor) return null;
      const pending =
        item.pendingChangeAttributes?.["productDescriptionClientVisibility"];
      const visibility: Visibility = !isUndefined(pending)
        ? pending
        : (item.product?.descriptionClientVisibility ?? "show");
      return (
        <VisibilityButton
          visibility={visibility}
          disabled={!options.canEdit}
          onChange={v =>
            options.modifyItemProduct(item.id, {
              productDescriptionClientVisibility: v,
            })
          }
        />
      );
    },
  };
}
